export default __webpack_public_path__ + "static/background-282be543df029a60fedca797bb6e26ef.png";